export default function validateDomain(value) {
  return /^(https?:\/\/)?([-a-zA-Z0-9@:%._\+~#=]{1,255}\.)?[-a-zA-Z0-9@:%._\+~#=]{1,253}\.[a-zA-Z0-9()]{1,63}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/i.test(
    value
  );
}
